import * as yup from 'yup';

const schema = yup.object().shape({
  REACT_APP_BACKEND_URL: yup.string().required(),
});

const validateEnv = (): { [key: string]: string } => {
  const envVars = {
    REACT_APP_BACKEND_URL: process.env.REACT_APP_BACKEND_URL as string,
  };

  schema.validateSync(envVars, { abortEarly: true });

  return envVars;
};

const settings = validateEnv();

export default settings;
